export function uploadImage(
  url: string,
  image: Blob,
  withContentType?: boolean
) {
  return fetch(url, {
    method: 'PUT',
    headers: {
      'content-type': withContentType ? image.type || '' : '',
    },
    body: image,
  }).then(res => (res.ok ? res : Promise.reject(res)));
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function getImage(url) {
  return fetch(url, {
    method: 'GET',
  }).then(response => {
    if (response.status !== 200) {
      throw new Error('bad Url');
    }
    return response.blob();
  });
}
